import React from 'react';
import Footer from '../../components/Shared/Footer';
import HomeHeader from '../Home/Home/HomeHeader/HomeHeader';
import BookAppoinment from './BookAppoinment/BookAppoinment';
import SEOHead from '../../components/SEO/SEOHead';
import { useTranslation } from 'react-i18next';

const Appointment = () => {
    const { i18n } = useTranslation();

    return (
        <>
            <SEOHead
                title={i18n.language === 'en' ? 'Appointment | Assoc. Prof. Dr. Ebru Karagün' : 'Randevu Al | Doç. Dr. Ebru Karagün'}
                description={i18n.language === 'en'
                    ? 'Book an appointment with Assoc. Prof. Dr. Ebru Karagün for dermatology and aesthetic dermatology treatments in Ankara.'
                    : 'Ankara’da dermatoloji ve estetik dermatoloji uygulamaları için Doç. Dr. Ebru Karagün’den randevu alın.'}
                image="/img/appoinment/appointment-bg.jpg"
                imageAlt={i18n.language === 'en'
                    ? 'Appointment and consultation visual for Assoc. Prof. Dr. Ebru Karagün clinic'
                    : 'Doç. Dr. Ebru Karagün klinigi randevu ve danisma gorseli'}
                trPath="/randevu-al"
                enPath="/en/appointment"
            />
            <HomeHeader/>
            <BookAppoinment/>
            <Footer/>
        </>
    );
};

export default Appointment;
